import { LoadingElement } from 'ii-react-sdk/layout_components';
import React from 'react';
import PermissionChecker from '~/components/permission_checker';
import Permissions from '~/settings/permissions';
import { Comment } from './comment';
import CommentInput from './comment_input';
const Comments = ({ isLoading, comments, documentComparisonId, }) => {
    var _a, _b;
    return (React.createElement(PermissionChecker, { requiredAllPermissions: [Permissions.VIEW_COMPARISON_COMMENTS] },
        React.createElement("div", { className: 'heading' },
            React.createElement("span", null,
                React.createElement("i", { className: "fa-regular fa-comments" }),
                "\u00A0 Comments (", (_a = comments === null || comments === void 0 ? void 0 : comments.length) !== null && _a !== void 0 ? _a : 0,
                ")")),
        React.createElement("div", { className: 'comments' },
            React.createElement("div", { className: 'comment-list' },
                isLoading && React.createElement(LoadingElement, { isLightBackground: true }),
                !isLoading && (comments === null || comments === void 0 ? void 0 : comments.sort((a, b) => {
                    return b.createdAt > a.createdAt ? -1 : 1;
                }).map(comment => (React.createElement(Comment, { key: comment.id, comment: comment }))))),
            React.createElement(PermissionChecker, { requiredAllPermissions: [Permissions.CREATE_COMPARISON_COMMENTS] },
                React.createElement(CommentInput, { commentsCount: (_b = comments === null || comments === void 0 ? void 0 : comments.length) !== null && _b !== void 0 ? _b : 0, documentComparisonId: documentComparisonId })))));
};
export default Comments;
